import { EuiSpacer, EuiText, EuiButton } from "@elastic/eui";
import React from "react";
import { useHistory } from "react-router-dom";

export const NIIHome: React.FC = () => {
  const history = useHistory();
  return (
    <div style={{ maxWidth: 800, margin: "0 auto" }}>
      <div>
        <EuiSpacer size="l" />
        <EuiText textAlign="center">
          <h1>Technology Business Development Fund</h1>
        </EuiText>
        {/* <EuiImage
                    size="fullWidth"
                    hasShadow
                    alt="NTBC & UNDB Acceleratory Lab"
                    url="https://res.cloudinary.com/ntbc-conduit/image/upload/v1602492395/thumbnail_UNDP_NTBC_ZICTA_-_Innovation_Scouting_03_bugegg.jpg"
                /> */}
        <EuiText>
          {/* <h1>National Innovation Initiative</h1> */}
          <EuiSpacer size="l" />
          {/* <EuiText textAlign="center">
            <h1>APPLICATIONS ClOSED</h1>
          </EuiText>
          <EuiSpacer /> */}
          <EuiSpacer />
          <div style={{ textAlign: "center" }}>
            <EuiButton
              onClick={() => history.push("/apply")}
              fill
              style={{ marginBottom: 8 }}
            >
              APPLY ONLINE
            </EuiButton>
            <EuiButton
              style={{ marginLeft: 8, marginBottom: 8 }}
              href={"./application-form-2026.docx"}
            >
              DOWNLOAD APPLICATION FORM
            </EuiButton>
            {/* <EuiButton
              style={{ marginLeft: 8, marginBottom: 8 }}
              href={"./tbdf-guidelines-2021.pdf"}
            >
              DOWNLOAD GUIDELINES
            </EuiButton> */}
          </div>
          <div style={{ margin: 24, textAlign: "center" }}>
            <p>
              The Government of the Republic of Zambia (GRZ) created the
              Technology Business Development Fund (TBDF) to support the
              development and commercialization of technological innovations.
              The Fund is administered under the Ministry of Technology and
              Science (MoTS) and implemented through the National Technology
              Business Centre (NTBC).
            </p>
            <p>
              In line with the 8th National Development Plan (8NDP) and the
              challenges the country is currently experiencing, the NTBC hereby
              invites eligible applicants to submit applications for funding
              under the Technology Business Development Fund (TBDF). The 2026
              Call is targeted at early-stage start-ups and promoters with
              &ldquo;Market-Ready&rdquo; innovative prototypes and/or products
              and services across three strategic priority focus areas:
              Integrated Agricultural Technologies, Tourism Technologies, and
              Manufacturing Technologies.
            </p>
            <p>
              This is an opportunity for you to turn your innovative business
              concept and technological innovation into a viable business
              venture by submitting your Concept Note through this call.
            </p>
            <p>Priority Focus Areas:</p>
            <div style={{ textAlign: "left" }}>
              <ol>
                <li>
                  <strong>
                    Integrated Agricultural Technologies (Crop Production,
                    Livestock & Aquaculture)
                  </strong>
                  <p>
                    This sector combines crop production, animal agriculture,
                    and aquaculture into a unified focus area, recognising the
                    interdependence of these systems in Zambia&rsquo;s
                    smallholder and commercial farming landscape and the
                    country&rsquo;s vast water resources.
                  </p>
                  <ul>
                    <li>Crop Production Technologies</li>
                    <li>Livestock and Animal Agriculture Technologies</li>
                    <li>Aquaculture Technologies</li>
                  </ul>
                </li>
                <li>
                  <strong>Tourism Technologies</strong>
                  <p>
                    Zambia is endowed with world-class natural and cultural
                    tourism assets including Victoria Falls, national parks,
                    and rich cultural heritage. This sector targets
                    technology-driven innovations that enhance the visitor
                    experience, improve destination management, and position
                    Zambia as a competitive and digitally-enabled tourism
                    destination.
                  </p>
                  <ul>
                    <li>
                      Digital Visitor Experience & Destination Management
                    </li>
                    <li>Immersive & Emerging Tourism Technologies</li>
                    <li>Heritage, Conservation & Data Analytics</li>
                  </ul>
                </li>
                <li>
                  <strong>Manufacturing Technologies</strong>
                  <p>
                    This sector targets innovations that strengthen
                    Zambia&rsquo;s industrial base by adding value to locally
                    available raw materials, improving production processes,
                    and building competitive manufacturing capacity aligned
                    with the country&rsquo;s industrialization agenda.
                  </p>
                  <ul>
                    <li>Natural Resource Value Addition</li>
                    <li>Industrial & Advanced Manufacturing</li>
                    <li>
                      Renewable & Non-Renewable Energy Manufacturing & Smart
                      Industry
                    </li>
                  </ul>
                </li>
              </ol>
            </div>
            <p>
              This initiative offers a unique opportunity for you to transform
              your prototype into a viable commercial venture while
              contributing to Zambia&rsquo;s agricultural, industrial, and
              technological development.
            </p>
            <p>Eligible Applicant Categories:</p>
            <div style={{ textAlign: "left" }}>
              <ul>
                <li>
                  Innovators & Start-ups / Entrepreneurs seeking to
                  commercialize their innovations
                </li>
                <li>
                  Research & Development Institutions, Universities, Colleges
                  or Trades Training Institutes &ndash; seeking technology
                  transfer & commercialization for their innovations
                </li>
                <li>
                  Agri-tech enterprises, digital platform developers, tourism
                  innovators, and manufacturing technology providers with
                  scalable, deployable solutions
                </li>
              </ul>
              <div style={{ textAlign: "center" }}>
                THE APPLICATIONS MUST BE SUBMITTED BY 30 JUNE 2026. <br />{" "}
                COMPLETED APPLICATION FORMS MUST BE ADDRESSED TO: <br /> The
                Director <br /> National Technology Business Centre <br /> 8th
                Floor, New Government Complex Nasser Road <br /> P.O. BOX RW
                51310, LUSAKA <br />
                <br />
                +260 211 222 355 / 473 <br />
                tbdf@ntbc.co.zm <br />
                @Ntbc_Zambia &nbsp;|&nbsp; @NtbcZambia
                <br />
                <br />
                <em>&ldquo;Growth through Innovation and Technology&rdquo;</em>
              </div>
            </div>
          </div>
        </EuiText>
        <EuiSpacer size="l" />
      </div>
    </div>
  );
};
